import { FC } from 'react';
import { Alert, Flex, Heading, HStack, Stack, Text } from '@chakra-ui/react';

import {
  ErrorMessage,
  TransformationErrors as TransformationErrorsType,
} from '../../graphql/generated';
type Props = {
  errors: TransformationErrorsType;
};

export const TransformationErrors: FC<Props> = ({ errors }) => {
  const renderFriendlyError = ({
    errType,
    column,
    row,
    value,
    raw,
  }: ErrorMessage) => (
    <Stack data-testid="friendly-transformation-error">
      <Heading fontSize="md" data-testid="error-message-title">
        {errType}
      </Heading>

      {!!column && (
        <HStack align="start" fontSize="sm" data-testid="error-column-body">
          <Text fontWeight={'semibold'}>Column: </Text>
          <Text as="span" fontWeight="500">
            "{column}"
          </Text>
        </HStack>
      )}

      {!!row && (
        <HStack align="start" fontSize="sm" data-testid="error-row-body">
          <Text fontWeight={'semibold'}>Row: </Text>
          <Text as="span" fontWeight="500">
            "{row}"
          </Text>
        </HStack>
      )}

      {!!value && (
        <HStack align="start" fontSize="sm" data-testid="error-value-body">
          <Text fontWeight={'semibold'}>Value: </Text>
          <Text as="span" fontWeight="500">
            "{value}"
          </Text>
        </HStack>
      )}

      {!!raw && (
        <HStack align="start" fontSize="sm" data-testid="error-raw-body">
          <Text fontWeight={'semibold'}>Raw: </Text>
          <Text as="span" fontWeight="500">
            "{raw}"
          </Text>
        </HStack>
      )}
    </Stack>
  );

  return (
    <Flex w="40rem" direction="column" data-testid="file-transformation-errors">
      <Heading data-testid="errors-heading" as="div" size="lg" mb="4">
        Validation Errors
      </Heading>
      {errors.messages.map((error) => {
        const uniqueKey = `${error.errType}-${error.column || 'no-col'}-${error.row || 'no-row'}-${error.raw || 'no-raw'}`;
        
        return (
          <Alert
            marginY="2"
            status="error"
            variant="left-accent"
            data-testid="error-message"
            key={uniqueKey}
          >
            <Stack>{renderFriendlyError(error)}</Stack>
          </Alert>
        );
      })}
    </Flex>
  );
};
